var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 100",
    d: "M17.693 9C17.693 13.8332 13.7875 17.75 8.97152 17.75C4.1555 17.75 0.25 13.8332 0.25 9C0.25 4.16676 4.1555 0.25 8.97152 0.25C13.7875 0.25 17.693 4.16676 17.693 9Z",
    fill: "#1877F2",
    fillOpacity: 0.2,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Orange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 38764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 120",
    d: "M4.80685 12.9614L3.72006 7.86647C3.70312 7.78707 3.78286 7.72165 3.85742 7.75377L6.85901 9.04666C6.90745 9.06753 6.96378 9.04718 6.9877 9.00016L8.96058 5.12166C8.99628 5.05146 9.09535 5.04817 9.13563 5.11584L11.4502 9.00338C11.4771 9.04862 11.5345 9.06523 11.5814 9.04135L14.0813 7.76972C14.1554 7.73203 14.2405 7.79596 14.2248 7.87762L13.2537 12.9593C13.2447 13.0064 13.2034 13.0405 13.1555 13.0405H4.90465C4.85746 13.0405 4.81669 13.0075 4.80685 12.9614Z",
    fill: "#6BAAFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 121",
    d: "M4.80685 12.9609L3.72016 7.86651C3.70321 7.78702 3.78314 7.72158 3.85772 7.7539L6.18241 8.76113C6.21192 8.77392 6.23348 8.80012 6.24035 8.83155L7.13308 12.9187C7.1467 12.9811 7.09921 13.04 7.03538 13.04H4.90465C4.85746 13.04 4.81669 13.0071 4.80685 12.9609Z",
    fill: "#C5DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 122",
    d: "M4.27446 10.5773L3.71787 7.86295C3.70169 7.78408 3.7806 7.71941 3.85476 7.75075L4.96577 8.22032C4.99555 8.23291 5.01741 8.25912 5.02445 8.29069L5.52454 10.5355C5.53846 10.5979 5.49093 10.6572 5.42693 10.6572H4.37243C4.32494 10.6572 4.284 10.6238 4.27446 10.5773Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 120_2",
    d: "M4.80685 12.9614L3.72006 7.86647C3.70312 7.78707 3.78286 7.72165 3.85742 7.75377L6.85901 9.04666C6.90745 9.06753 6.96378 9.04718 6.9877 9.00016L8.96058 5.12166C8.99628 5.05146 9.09535 5.04817 9.13563 5.11584L11.4502 9.00338C11.4771 9.04862 11.5345 9.06523 11.5814 9.04135L14.0813 7.76972C14.1554 7.73203 14.2405 7.79596 14.2248 7.87762L13.2537 12.9593C13.2447 13.0064 13.2034 13.0405 13.1555 13.0405H4.90465C4.85746 13.0405 4.81669 13.0075 4.80685 12.9614Z",
    stroke: "black",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionBlue);
export default __webpack_public_path__ + "static/media/permissionBlue.a8b1043d5f99368879d61d1732ff898b.svg";
export { ForwardRef as ReactComponent };